<div class="jd-container">
  <mat-card class="jd-card">
    <div class="jd-card-content">
      <div *ngIf="loading">
        <mat-icon class="jd-icon">sync</mat-icon>
        <p class="jd-description">Completing connection...</p>
      </div>

      <div *ngIf="error">
        <mat-icon class="jd-icon error">error_outline</mat-icon>
        <h2>Connection Failed</h2>
        <p class="jd-error">{{ error }}</p>
        <button mat-raised-button color="primary" class="jd-button" routerLink="/john-deere/connect">Try Again</button>
      </div>
    </div>
  </mat-card>
</div>
